import { render, staticRenderFns } from "./MoreFilter.vue?vue&type=template&id=64b381d0&scoped=true"
import script from "./MoreFilter.vue?vue&type=script&lang=js"
export * from "./MoreFilter.vue?vue&type=script&lang=js"
import style0 from "./MoreFilter.vue?vue&type=style&index=0&id=64b381d0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b381d0",
  null
  
)

export default component.exports